import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import ContentLoader from 'react-content-loader';

import styles from './styles';

const getTableRow = () => (
  <TableRow>
    <TableCell>
      <ContentLoader height={20}>
        <rect x="0" y="0" rx="3" ry="3" width="360" height="20" />
      </ContentLoader>
    </TableCell>
    <TableCell>
      <ContentLoader height={80}>
        <circle rx="0" ry="0" cx="40" cy="40" r="40" height="80" />
        <rect x="100" y="35" rx="5" ry="5" width="200" height="20" />
      </ContentLoader>
    </TableCell>
    <TableCell>
      <ContentLoader height={20}>
        <rect x="0" y="0" rx="3" ry="3" width="100" height="20" />
      </ContentLoader>
    </TableCell>
    <TableCell>
      <ContentLoader height={60}>
        <circle rx="0" ry="0" cx="30" cy="30" r="30" height="60" />
      </ContentLoader>
    </TableCell>
    <TableCell />
  </TableRow>
);

class EventListContentLoaderComponent extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <Paper className={classes.conatiner}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell varient="head">Name</TableCell>
              <TableCell varient="head">Status</TableCell>
              <TableCell varient="head">Created</TableCell>
              <TableCell varient="head">Contributors</TableCell>
              <TableCell varient="head" />
            </TableRow>
          </TableHead>
          <TableBody>
            {getTableRow()}
            {getTableRow()}
            {getTableRow()}
            {getTableRow()}
            {getTableRow()}
          </TableBody>
        </Table>
      </Paper>
    );
  }
}

EventListContentLoaderComponent.propTypes = { classes: PropTypes.object };

EventListContentLoaderComponent.defaultProps = { classes: {} };

export default withStyles(styles)(EventListContentLoaderComponent);
